import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { getSessionStoragePrefs, setSessionStoragePrefs } from "./Storage";
import Article from "./components/Article";
import Collection from "./components/Collection";
import CollectionList from "./components/CollectionList";
import { AppContext } from "./appContext";
import ChatTabsList from "./components/ChatTabsList";
import { HC_ACTIVE_COMPONENT, HC_ACTIVE_ID, HC_SEARCH_TEXT } from "./globals";
import CollectionDashboard from "./components/new/CollectionDashboard";
export default function HelpCenter() {
    var parentContext = useContext(AppContext);
    var setPromtWidth = parentContext.setPromtWidth;
    var HCComponentNames;
    (function (HCComponentNames) {
        HCComponentNames["CollectionList"] = "CollectionList";
        HCComponentNames["Collection"] = "Collection";
        HCComponentNames["Article"] = "Article";
        HCComponentNames["V2Dashboard"] = "V2Dashboard";
    })(HCComponentNames || (HCComponentNames = {}));
    var _a = useState(null), version = _a[0], setVersion = _a[1];
    var _b = useState(), v2CollectionsData = _b[0], setV2CollectionsData = _b[1];
    var _c = useState([]), collections = _c[0], setCollections = _c[1];
    var _d = useState([]), articles = _d[0], setArticles = _d[1];
    var _e = useState(), activeCollection = _e[0], setActiveCollection = _e[1];
    var _f = useState(), activeArticleId = _f[0], setActiveArticleId = _f[1];
    var _g = useState(HCComponentNames[((getSessionStoragePrefs(HC_ACTIVE_COMPONENT) != null && getSessionStoragePrefs(HC_ACTIVE_COMPONENT) != "V2Dashboard")
        ? getSessionStoragePrefs(HC_ACTIVE_COMPONENT)
        : HCComponentNames.CollectionList)]), activeComponentName = _g[0], setActiveComponentName = _g[1];
    var _h = useState(getSessionStoragePrefs(HC_SEARCH_TEXT) != null
        ? getSessionStoragePrefs(HC_SEARCH_TEXT)
        : ""), searchTxt = _h[0], setSearchTxt = _h[1];
    useEffect(function () {
        setSessionStoragePrefs(HC_ACTIVE_COMPONENT, activeComponentName);
    }, [activeComponentName]);
    useEffect(function () {
        setSessionStoragePrefs(HC_SEARCH_TEXT, searchTxt);
    }, [searchTxt]);
    // Handle version change
    useEffect(function () {
        if (version && version.toLowerCase() === "v2") {
            setActiveComponentName(HCComponentNames.V2Dashboard);
        }
    }, [version]);
    var openCollection = function (collectionId) {
        setSessionStoragePrefs(HC_ACTIVE_ID, collectionId);
        setActiveCollection(collections.find(function (collection) { return collection.id == collectionId; }));
        setActiveComponentName(HCComponentNames.Collection);
    };
    var openArticle = function (articleId) {
        setSessionStoragePrefs(HC_ACTIVE_ID, articleId);
        setActiveArticleId(articleId);
        setActiveComponentName(function (previous) {
            if (previous == HCComponentNames.CollectionList)
                setActiveCollection(undefined);
            return HCComponentNames.Article;
        });
    };
    var backToCollectionList = function () {
        setSessionStoragePrefs(HC_ACTIVE_ID, null);
        setActiveComponentName(HCComponentNames.CollectionList);
    };
    var backToCollection = function (collectionId) {
        if (searchTxt && !activeCollection)
            backToCollectionList();
        else {
            setSessionStoragePrefs(HC_ACTIVE_ID, collectionId);
            setActiveComponentName(HCComponentNames.Collection);
        }
    };
    useEffect(function () {
        setSessionStoragePrefs(HC_ACTIVE_COMPONENT, activeComponentName);
    }, [activeComponentName]);
    return (_jsxs(_Fragment, { children: [(function () {
                switch (activeComponentName) {
                    case HCComponentNames.V2Dashboard: {
                        return (_jsx(CollectionDashboard, { items: v2CollectionsData || [], searchTxt: searchTxt, setSearchTxt: setSearchTxt }));
                    }
                    case HCComponentNames.Article: {
                        return (_jsx(Article, { articleId: activeArticleId, backToCollection: backToCollection }));
                    }
                    case HCComponentNames.Collection: {
                        return (_jsx(Collection, { collection: activeCollection, setCollection: setActiveCollection, openArticle: openArticle, backToCollectionList: backToCollectionList }));
                    }
                    case HCComponentNames.CollectionList: {
                        return (_jsx(CollectionList, { openCollection: openCollection, setCollections: setCollections, collections: collections, setArticles: setArticles, searchTxt: searchTxt, openArticle: openArticle, setSearchTxt: setSearchTxt, articles: articles, setVersion: setVersion, setV2CollectionsData: setV2CollectionsData }));
                    }
                    default:
                        return _jsx(_Fragment, {});
                }
            })(), activeComponentName == HCComponentNames.CollectionList ||
                activeComponentName == HCComponentNames.Collection ||
                activeComponentName == HCComponentNames.V2Dashboard ? (_jsx(ChatTabsList, {})) : (_jsx(_Fragment, {}))] }));
}
